import { useQuery } from "@tanstack/react-query";

import * as api from "./api";
import useCustomMutation from "src/hooks/useCustomMutation";

export const useGetAllUserFacility = () => useQuery({
    queryFn: api.getAllfacilityRequest,
    queryKey: ["getAllfacilityRequest"],
    gcTime: 0
});

export const useGetFacilityRequestById = (facilityId: number) => useQuery({
    queryFn: () => api.getFacilityRequestById(facilityId),
    queryKey: ["getFacilityRequestById", facilityId]
});

export const useGetUserFacilityHistory = () => useQuery({
    queryFn: api.getUserFacilityHistory,
    queryKey: ["getUserFacilityHistory"]
});

export const useDeleteFacilityInquiry = () => useCustomMutation({
    mutationFn: api.deleteFacilityInquiry,
    queryKey: "getAllfacilityRequest"
});

export const useGetFacilityRequestFlow = (facilityId: number) => useQuery({
    queryFn: () => api.getFacilityRequestFlow(facilityId),
    queryKey: ["getFacilityRequestFlow", facilityId],
    gcTime: 0
});

export const useSelectProvider = () => useCustomMutation({
    mutationFn: api.selectProvider,
    showMessage: false,
    queryKey: "getFacilityRequestFlow"
});

export const useGetBankInquiry = (facilityId: number) => useQuery({
    queryFn: () => api.getBankInquiry(facilityId),
    queryKey: ["getBankInquiry"]
});

export const useGetFacilityUserInfo = () => useQuery({
    queryFn: api.getFacilityUserInfo,
    queryKey: ["getFacilityUserInfo"]
});

export const useInquiryPostalCode = () => useCustomMutation({
    mutationFn: api.inquiryPostalCode,
    showMessage: false,
});

export const useInquiryUserCard = () => useCustomMutation({
    mutationFn: api.inquiryUserCard,
    showMessage: false,
});

export const useRegisterFacilityUserInfo = () => useCustomMutation({
    mutationFn: api.registerFacilityUserInfo,
    showMessage: false
});

export const useGetDocumentTypeBasedOnCareer = (careerStatus: number) => useQuery({
    queryFn: () => api.getDocumentTypeBasedOnCareer(careerStatus),
    queryKey: ["getDocumentTypeBasedOnCareer", careerStatus],
    enabled: !!careerStatus
});

export const useSetEducationAndCareerInformation = () => useCustomMutation({
    mutationFn: api.setEducationAndCareerInformation,
});

export const useGetJetClubPlanList = () => useQuery({
    queryFn: api.getJetClubPlanList,
    queryKey: ["getJetClubPlanList"]
});

export const useAssignCredit = () => useCustomMutation({
    mutationFn: api.assignCredit
});

export const useUploadChequeImage = () => useCustomMutation({
    mutationFn: api.uploadChequeImage,
    showMessage: false,
});